// extracted by mini-css-extract-plugin
module.exports =  {"alert":"XbMG9nofNypxmZdRN6NQ"};